import { Link } from "react-router-dom";
import { PlayButton } from "@/components/PlayButton";
import { ExpandableText } from "@/components/ExpandableText";
import { mediaShape } from "@/components/EpisodeHero";
import { usePlayer } from "@/context/PlayerContext";
import { timeAgo, imgUrl } from "@/lib/api";

export const EpisodeCard = ({ episode, index, showLink = true, onSelect, onReadMore }) => {
  const { isPlaying } = usePlayer();
  const active = isPlaying(episode.id);
  const img = imgUrl(episode.image_url || episode.show?.cover_url);
  const { aspect } = mediaShape(episode);
  const width = aspect === "aspect-video" ? "w-36 sm:w-44" : aspect === "aspect-[9/16]" ? "w-20 sm:w-24" : "w-24 sm:w-28";
  const Wrap = ({ className, children, testId }) => onSelect
    ? <button type="button" onClick={() => onSelect(episode)} className={`${className} text-left`} title="Feature this episode" data-testid={testId}>{children}</button>
    : <Link to={`/episodes/${episode.id}`} className={className} data-testid={testId}>{children}</Link>;
  return (
    <article onClick={onSelect ? () => onSelect(episode) : undefined} className={`card-surface card-surface-hover rounded-2xl p-4 flex gap-4 reveal min-w-0 w-full ${active ? "now-playing" : ""} ${onSelect ? "cursor-pointer" : ""}`} style={{ animationDelay: `${Math.min(index, 11) * 60}ms` }} data-testid={`episode-card-${index}`} data-playing={active}>
      <div className={`shrink-0 flex flex-col gap-2 ${width}`}>
        <Wrap className={`${aspect} w-full rounded-xl overflow-hidden ring-1 ring-white/10 block`} testId={`episode-card-artwork-${index}`}>
          <img src={img} alt="" className="h-full w-full object-cover" loading="lazy" />
        </Wrap>
        <div onClickCapture={onSelect ? () => onSelect(episode) : undefined}><PlayButton episode={episode} variant="wide" testId={`episode-play-button-${index}`} /></div>
      </div>
      <div className="min-w-0 flex flex-col">
        <div className="flex items-center gap-2 min-w-0">
          {showLink && episode.show && (
            <Link to={`/shows/${episode.show.slug}`} className="text-xs font-bold text-sky-400 uppercase tracking-wider truncate hover:underline" data-testid={`episode-card-show-${index}`}>{episode.show.name}</Link>
          )}
          {active && <span className="bars flex items-end h-4 shrink-0" aria-label="Now playing" data-testid={`episode-card-now-playing-${index}`}><span /><span /><span /><span /></span>}
        </div>
        <Wrap className="mt-1 block hover:text-sky-300 transition-colors" testId={`episode-card-title-link-${index}`}>
          <h3 className="font-display font-bold text-base leading-snug line-clamp-2 min-h-[2.75rem]" data-testid={`episode-card-title-${index}`}>{episode.title}</h3>
        </Wrap>
        <ExpandableText text={episode.summary} full={episode.description} lines={2} className="mt-1.5 text-sm text-slate-400" testId={`episode-card-summary-${index}`} title={episode.title} eyebrow={episode.show?.name} onOpen={onReadMore ? () => onReadMore(episode) : undefined} />
        <p className="mt-auto pt-2 font-mono text-[11px] text-slate-500">{timeAgo(episode.published_at)}{episode.duration ? ` · ${episode.duration}` : ""}</p>
      </div>
    </article>
  );
};
